var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from '../../framework/AsciiText';
import { Timeouts } from '../../framework/Timeouts';
export const channelConfiguration = [
    { name: 'Automix Output', startNumbering: 1, count: 1, type: 'automixerOutput' },
    { name: 'Input', startNumbering: 1, count: 32, type: 'input' },
    { name: 'Output', startNumbering: 1, count: 32, type: 'output' },
    { name: 'Preset', startNumbering: 1, count: 16, type: 'preset' },
];
export class AlfatronDspBase {
    constructor(log) {
        this.log = log;
        this.automixerOutputs = [];
        this.inputs = [];
        this.outputs = [];
        this.presets = [];
        this.timeouts = new Timeouts();
        this.asyncHandlers = [
            {
                name: 'autoMixerMute',
                regExp: /\xb3(\x22|\x21)[\s\S]\x00\xa1\x00\x01\x00([\s\S])[\s\S]{3}/,
                callback: (match) => {
                    const commandType = match[1].charCodeAt(0);
                    let mute = match[2].charCodeAt(0) === 0x01;
                    const automixer = this.automixerOutputs[0];
                    if (automixer === undefined) {
                        this.log.error(`no automixer defined`);
                        return;
                    }
                    if (commandType === 0x22) {
                        mute = automixer.mute;
                    }
                    else {
                        automixer.mute = mute;
                    }
                    this.send(this.makeCommand([
                        0xb3,
                        commandType,
                        0x00,
                        0xe0,
                        0xa1,
                        0x00,
                        0x01,
                        0x00,
                        mute ? 0x01 : 0x00,
                        0x00,
                        0x00,
                        0x00,
                    ]));
                },
            },
            {
                name: 'autoMixerGain',
                regExp: /\xb3(\x22|\x21)[\s\S]\x00\xa1\x00\x02\x00([\s\S]{2})[\s\S]{2}/,
                callback: (match) => {
                    const commandType = match[1].charCodeAt(0);
                    let volume = match[2].charCodeAt(0) + (match[2].charCodeAt(1) << 8);
                    const automixer = this.automixerOutputs[0];
                    if (automixer === undefined) {
                        this.log.error(`no automixer defined`);
                        return;
                    }
                    if (commandType === 0x22) {
                        volume = automixer.volume;
                    }
                    else {
                        automixer.volume = volume;
                    }
                    this.send(this.makeCommand([
                        0xb3,
                        commandType,
                        0x00,
                        0xe0,
                        0xa1,
                        0x00,
                        0x02,
                        0x00,
                        volume & 0x00ff,
                        (volume & 0xff00) >> 8,
                        0x00,
                        0x00,
                    ]));
                },
            },
            {
                name: 'mute',
                regExp: /\xb3(\x22|\x21)[\s\S]\x00(\x2b\x01|\x27\x01)\x02\x00([\s\S]{2})([\s\S]{2})/,
                callback: (match) => {
                    const commandType = match[1].charCodeAt(0);
                    const isInput = match[2].charCodeAt(0) === 0x2b;
                    const chanNum = match[3].charCodeAt(0);
                    let mute = match[4].charCodeAt(0) === 0x01;
                    const channel = isInput ? this.inputs[chanNum] : this.outputs[chanNum];
                    if (channel === undefined) {
                        this.log.error(`${isInput ? 'input' : 'output'} channel ${chanNum} not defined`);
                        return;
                    }
                    if (commandType === 0x22) {
                        mute = channel.mute;
                    }
                    else {
                        channel.mute = mute;
                    }
                    this.send(this.makeCommand([
                        0xb3,
                        commandType,
                        0x00,
                        0xe0,
                        match[2].charCodeAt(0),
                        match[2].charCodeAt(1),
                        0x02,
                        0x00,
                        chanNum,
                        0x00,
                        mute ? 0x01 : 0x00,
                        0x00,
                    ]));
                },
            },
            {
                name: 'volume',
                regExp: /\xb3(\x22|\x21)[\s\S]\x00([\s\S]{2})\x01\x00([\s\S]{2})([\s\S]{2})/,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    const commandType = match[1].charCodeAt(0);
                    const isInput = match[2].charCodeAt(0) === 0x2b;
                    const chanNum = match[3].charCodeAt(0);
                    let volume = (match[4].charCodeAt(0) & 0x00ff) + (match[4].charCodeAt(1) << 8);
                    const channel = isInput ? this.inputs[chanNum] : this.outputs[chanNum];
                    if (channel === undefined) {
                        this.log.error(`${isInput ? 'input' : 'output'} channel ${chanNum} not defined`);
                        return;
                    }
                    if (commandType === 0x22) {
                        volume = channel.volume;
                    }
                    else {
                        channel.volume = volume;
                    }
                    // The Alfatron can take a while to respond to volume commands. We emulate that here
                    // so see the effects when testing.
                    yield this.timeouts.delay(500);
                    this.send(this.makeCommand([
                        0xb3,
                        commandType,
                        0x00,
                        0xe0,
                        match[2].charCodeAt(0),
                        match[2].charCodeAt(1),
                        0x01,
                        0x00,
                        chanNum,
                        0x00,
                        volume & 0x00ff,
                        (volume >> 8) & 0x00ff,
                    ]));
                }),
            },
            {
                name: 'preset',
                regExp: /\xb3\x13[\s\S]\x00([\s\S]{2})[\s\S]{6}/,
                callback: (match) => {
                    const presetNum = match[1].charCodeAt(0);
                    const preset = this.presets[presetNum];
                    if (preset === undefined) {
                        this.log.error(`preset ${presetNum} not defined`);
                        return;
                    }
                    this.send(this.makeCommand([
                        0xb3,
                        0x13,
                        0x00,
                        0xe0,
                        presetNum,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                    ]));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/,
                callback: (match) => {
                    // nothing is sent
                },
            },
        ];
        for (const config of channelConfiguration) {
            if (config.type === 'automixerOutput') {
                for (let i = 0; i < config.count; i++) {
                    this.automixerOutputs[i] = { channelNumber: i, mute: false, volume: 0 };
                }
            }
            else if (config.type === 'input') {
                for (let i = 0; i < config.count; i++) {
                    this.inputs[i] = { channelNumber: i, mute: false, volume: 0 };
                }
            }
            else if (config.type === 'output') {
                for (let i = 0; i < config.count; i++) {
                    this.outputs[i] = { channelNumber: i, mute: false, volume: 0 };
                }
            }
            else if (config.type === 'preset') {
                for (let i = 0; i < config.count; i++) {
                    this.presets[i] = { presetNumber: i };
                }
            }
            else {
                log.error(`invalid config type: ${config.type}`);
            }
        }
    }
    makeCommand(data) {
        return AsciiText.decode(data);
    }
    onConfigure(config) {
        this.timeouts.clearAll();
    }
    onDisconnect() {
        this.timeouts.clearAll();
    }
}
